import { BCPLayer } from "@/Utils/hierarchy";

export interface ROIDataPoint {
  date: string;
  roi: number | null;
  hideROI: boolean;
  [channel: string]: number | string | null | boolean | undefined;
  geography?: string | null;
}

export interface RevenueDataPoint {
  date: string;
  totalRevenue: number | string | null | boolean | undefined;
}

export interface TotalSpendDataPoint {
  date: string;
  totalSpend: number | string | null | boolean | undefined;
}

export type FlightingData = {
  id: string;
  date: string;
  channel: string;
  mappedName: string;
  spend: { [key in BCPLayer]: number };
  revenue: { [key in BCPLayer]: number };
  geography?: string;
};

export type FlightingROIMap = Map<string, FlightingData[]>;

export type ROIWindow = 4 | 12;

export enum ChartToggle {
  SPEND = "Spend",
  REVENUE = "Revenue",
  ROI = "ROI",
}

export interface ChannelData {
  name: string;
  value: number;
  color: string;
}
